var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangePeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "networking--04_1_",
    d: "M13,18.64H1c-0.199,0-0.36,0.161-0.36,0.36v12c0,0.199,0.161,0.36,0.36,0.36h12 c0.199,0,0.36-0.161,0.36-0.36V19C13.36,18.801,13.199,18.64,13,18.64z M12.64,30.64H1.36V19.36h11.28 C12.64,19.36,12.64,30.64,12.64,30.64z M25,0.64c-3.507,0-6.36,2.853-6.36,6.36s2.854,6.36,6.36,6.36s6.36-2.853,6.36-6.36 S28.507,0.64,25,0.64z M25,12.64c-3.11,0-5.64-2.53-5.64-5.64S21.89,1.36,25,1.36S30.64,3.89,30.64,7S28.11,12.64,25,12.64z  M9.36,26.5c0-0.615-0.3-1.161-0.761-1.5c0.461-0.339,0.761-0.885,0.761-1.5c0-1.025-0.834-1.86-1.86-1.86H4.641v6.721H7.5 C8.525,28.36,9.36,27.525,9.36,26.5z M5.36,22.36H7.5c0.628,0,1.14,0.511,1.14,1.14s-0.512,1.14-1.14,1.14H5.36V22.36z M5.36,25.36 H7.5c0.628,0,1.14,0.511,1.14,1.14s-0.512,1.14-1.14,1.14H5.36V25.36z M24.64,15h0.721v8c0,1.302-1.059,2.36-2.36,2.36H16.37 l2.214,2.213l-0.51,0.51L14.991,25l3.083-3.083l0.51,0.51L16.37,24.64H23c0.904,0,1.64-0.735,1.64-1.64V15z M17.009,7l-3.083,3.083 l-0.509-0.509l2.214-2.214H9C8.096,7.36,7.36,8.096,7.36,9v8H6.64V9c0-1.301,1.059-2.36,2.36-2.36h6.631l-2.214-2.214l0.509-0.509 L17.009,7z M24.671,3.862l-2.386,6l0.67,0.266l0.705-1.773h2.691l0.705,1.773l0.67-0.266l-2.385-6 C25.341,3.862,24.671,3.862,24.671,3.862z M23.946,7.635l1.06-2.666l1.059,2.666H23.946z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePeopleIcon);
export default __webpack_public_path__ + "static/media/ChangePeopleIcon.27d61083e134bcea8cdd10b2e25a005e.svg";
export { ForwardRef as ReactComponent };